import React from 'react'
import { Grid, AppBar, Dialog, IconButton, makeStyles, Slide, Toolbar, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { ArrowBack } from '@material-ui/icons'

import useViewportSizes from '~/components/useViewportSize'
import ProductsGrid from './ProductsGrid'
import ProductsList from './ProductsList'
import { useLiterals } from '~/components/Literals'

const useStyles = makeStyles((theme) => ({
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ProductListDialog({ open, setOpen, products, handleProductClick }) {
  const theme = useTheme()
  const classes = useStyles()
  const viewport = useViewportSizes()
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth
  const { getLiteral } = useLiterals()

  const handleClose = () => setOpen(false)

  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton size="small" edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <ArrowBack />
          </IconButton>
          <Typography variant="button" className={classes.title} align="center">
            {getLiteral('2501')}
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid style={{ marginTop: 70 }}>
        {isMobile ? (
          <ProductsList products={products} handleProductClick={handleProductClick} />
        ) : (
          <ProductsGrid products={products} />
        )}
      </Grid>
    </Dialog>
  )
}
